import React from 'react';

import { type HubAppProps } from './types';

export const Card = ({
	url = '',
	onError = (_error: any) => {},
	children = <></>,
}: {
	children?: React.JSX.Element | undefined;
	onError?: ((_error: any) => void) | undefined;
	url?: string | undefined;
}): React.JSX.Element => (
	<div data-testid={`smart-card-${url}`}>
		<button onClick={() => onError({ status: 'not_found' })}>Trigger not_found error status</button>
		<button onClick={() => onError({ status: 'unauthorized' })}>
			Trigger unauthorized error status
		</button>
		<button onClick={() => onError({ status: 'forbidden' })}>Trigger forbidden error status</button>
		{children}
	</div>
);

export const CardSSR: ({
	url,
	onError,
	children,
}: {
	children?: React.JSX.Element | undefined;
	onError?: ((_error: any) => void) | undefined;
	url?: string | undefined;
}) => React.JSX.Element = Card;

export const MetadataBlock = ({
	primary = [],
}: {
	primary?: never[] | undefined;
}): React.JSX.Element => (
	<div>
		{primary.map(({ name }) => (
			<div key={name}>Primary metadata: {name}</div>
		))}
	</div>
);

export const CustomBlock = ({
	children = <></>,
}: {
	children?: React.JSX.Element | undefined;
}): React.JSX.Element => (
	<div>
		CustomBlock
		{children}
	</div>
);

export const PreviewBlock = ({
	overrideUrl = 'NONE',
}: {
	overrideUrl?: string | undefined;
}): React.JSX.Element => <div>Preview: {overrideUrl}</div>;

export const SnippetBlock = ({ text = '' }: { text?: string | undefined }): React.JSX.Element => (
	<div>Snippet: {text}</div>
);

export const TitleBlock = ({
	metadata = [],
	text = '',
}: {
	metadata?: never[] | undefined;
	text?: string | undefined;
}): React.JSX.Element => (
	<div>
		{!!text ? text : 'TitleBlock'}
		{metadata.map(({ name }) => (
			<div key={name}>Metadata: {name}</div>
		))}
	</div>
);

export const mockHubRouteProps: HubAppProps = {
	actions: {
		onLogoutClick: () => ({ type: 'epic.logout.LOG_OUT' }),
	},
	env: {
		cloudId: '17554ffe-ef18-4562-8222-e295e81a46bb',
		helpCenterAri:
			'ari:cloud:help::help-center/5b32ba66-fea2-4010-893d-278bfac050bc/5e67e6f9-7753-41fa-811b-55cb9fd71897',
		helpCenterId: '5e67e6f9-7753-41fa-811b-55cb9fd71897',
		hoistedProjectKey: 'TR',
		hubEditMode: false,
		jiraDisplayUrl: '/',
		relativeBaseUrl: '/',
	},
	layout: {
		bannerText: '',
		isAnonymousRoute: false,
		showBanner: false,
	},
	user: {
		avatarSrc: '',
		displayName: 'test_name',
		email: 'test@atlassian.com',
		id: 'some_random_id',
		isJiraAdmin: false,
	},
};
